import * as React from 'react';

const ArrowRight = props => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      fillRule="nonzero"
      d="M12.586,7 L7.293,1.707 C6.902,1.317 6.902,0.683 7.293,0.293 C7.683,-0.098 8.317,-0.098 8.707,0.293 L15.707,7.293 C16.098,7.683 16.098,8.317 15.707,8.707 L8.707,15.707 C8.317,16.098 7.683,16.098 7.293,15.707 C6.902,15.317 6.902,14.683 7.293,14.293 L12.586,9 L1,9 C0.448,9 0,8.552 0,8 C0,7.448 0.448,7 1,7 L12.586,7 Z"
    />
  </svg>
);

export default ArrowRight;



// WEBPACK FOOTER //
// ./src/assets/images/icons/arrow-right.js